// extracted by mini-css-extract-plugin
module.exports = {"itemSectionDescriptionJtails":"SectionDescription-Jtails_itemSectionDescriptionJtails_3W_7N","isStyleDingBeauty":"SectionDescription-Jtails_isStyleDingBeauty_GOBLe"};